.OverlayFilters {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: var(--overlay); */
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.2);
  overflow-y: auto;
}

.VeduteInsiemeContainer {
  border-radius: 30px 30px 0px 0px;
  background: var(--overlay);
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  padding: 16px 24px 24px 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: fixed;
  min-height: 180px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
}

.Title {
  color: var(--primary);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.Description {
  color: var(--primary);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
